import Vue from 'vue';
import { http, queryString, notify } from 'utils'
import { map, flatten, omit, concat, findIndex } from 'lodash'

import { SET_COSTING, SET_COSTING_LINES, SET_COSTING_LINE, ADD_COSTING_LINE, SET_PROPERTY } from 'vx/mutations'

const state = {
    costing: {},
    lines: []
}

const getters = {
    getLineByEpicId: (state) => (id) => {
        return state.lines.find(line => line.epic_id === id)
    },

    getLineByStoryId: (state) => (id) => {
        return state.lines.find(line => line.story_id === id)
    },

    getBaseLine: (state) => {
        return state.lines.length ? state.lines[0] : null
    }
}

const actions = {

    async getCosting ({ commit }, id) {
        commit(SET_COSTING, {})
        commit(SET_COSTING_LINES, [])

        const response = await http.get(`/user-story-document/${id}/costing`)

        commit(SET_COSTING_LINES, response.data.lines)
        delete response.data.lines
        commit(SET_COSTING, response.data)

        return response
    },

    async reCalculateCosting ({ commit }, id) {

        const response = await http.get(`/user-story-document/${id}/costing`)

        response.data.lines.forEach((rline) => {

            let index = findIndex(state.lines, line => line.id === rline.id)

            if (index == -1) {
                commit(ADD_COSTING_LINE, rline)
            } else {
                commit(SET_COSTING_LINE, {index, rline})
            }
        })

        //commit(SET_COSTING_LINES, response.data.lines)
        delete response.data.lines
        commit(SET_COSTING, response.data)

        return response
    },

    setLineProperty({ commit }, payload) {
        commit(SET_PROPERTY, payload)
    },

    async updateCosting ({ commit }, {userStoryDocumentId, costingId, payload} ) {
        return await http.put(`/user-story-document/${userStoryDocumentId}/costing/${costingId}`, payload).catch(function (error) {

            if (error.response.status === 422) {
                notify.error('Form validation failed, please check your inputs and try again.')
            }

            if (error.response) {
              if (error.response.data.message) {
                notify.error("API Error: " + error.response.status + " <br> " + error.response.data.message)
              } else {
                notify.error("API Error: " + error.response.status + " <br> " + error.response.statusText)
              }
            }

            throw error
        })
    },

    async useTemplate ({ commit }, {opportunityId, payload} ) {
        return await http.post(`/opportunities/${opportunityId}/usetemplate`, payload).catch(function (error) {

            if (error.response.status === 422) {
                notify.error('Form validation failed, please check your inputs and try again.')
            }

            if (error.response) {
                notify.error("API Error: " + error.response.status + " <br> " + error.response.statusText)
            }
        })
    },

    //Route::put('/projects/{projectId}/costing/{costingId}/line/{lineId}', 'Projects\ProjectCostingLineController@update');
    async updateCostingLine ({ commit }, {userStoryDocumentId, costingId, lineId, payload} ) {
        return await http.put(`/user-story-document/${userStoryDocumentId}/costing/${costingId}/line/${lineId}`, payload).catch(function (error) {

            if (error.response.status === 422) {
                notify.error('Form validation failed, please check your inputs and try again.')
            }

            if (error.response) {
              if (error.response.data.message) {
                notify.error("API Error: " + error.response.status + " <br> " + error.response.data.message)
              } else {
                notify.error("API Error: " + error.response.status + " <br> " + error.response.statusText)
              }
            }
        })
    },

}

// User state mutations.
const mutations = {

  /**
  * Set the stages state.
  */
  [SET_COSTING] (state, cositng) {
    state.costing = cositng
  },

  [SET_COSTING_LINE] (state, {index, rline}) {
    state.lines.splice(index, 1, rline)
  },
  [ADD_COSTING_LINE] (state, line) {
    state.lines.push(line)
  },

  [SET_COSTING_LINES] (state, lines) {
    Vue.set(state, 'lines', lines)
  },

  [SET_PROPERTY] (state, {property, value, index} ) {
    Vue.set(state.lines[index], property, value)
  },
}

// Export our state, getters, actions, mutations, and modules.
export default {
  namespaced: true, state, getters, actions, mutations
}
